import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-balance-over-limit',
  templateUrl: './balance-over-limit.component.html',
  styleUrls: ['./balance-over-limit.component.css']
})
export class BalanceOverLimitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/balance-over-limit/balance-over-limit.component.ts